export default {
  setIncomeGLAccount: (state, payload) => {
    state.incomeGl = payload
  },
  setIncomeGLByParentCategory: (state, payload) => {
    state.incomeGlByParentCategory = payload
  },
  setStationaryAccount: (state, payload) => {
    state.stationaryGL = payload
  },
  setLevelTwoCategory: (state, payload) => {
    state.levelTwoCategory = payload
  },
  setLevelThreeCategory: (state, payload) => {
    state.levelThreeCategory = payload
  },
  setIFRSCategory: (state, payload) => {
    state.ifrsCategory = payload
  },
  setBranches: (state, accountOfficers) => {
    state.accountOfficers = accountOfficers
  },
  resetAccountState(state) {
    Object.keys(state).forEach(key => { state[key] = null })
  },
  setTillAccountBalance: (state, payload) => {
    state.tillAccountBalance = payload
  },
}
